import CategoriaEstoqueService from "@/services/CategoriaEstoqueService";

export const categoriaEstoque = {
  namespaced: true,
  state: {
    categoriaEstoque: {},
  },
  actions: {
    getCategoriaEstoque({ commit }, payload) {
      return CategoriaEstoqueService.GetCategoriaEstoque(payload).then(
        (categoriaEstoque) => {
          return Promise.resolve(categoriaEstoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCategoriaEstoque({ commit }, payload) {
      return CategoriaEstoqueService.PostCategoriaEstoque(payload).then(
        (categoriaEstoque) => {
          return Promise.resolve(categoriaEstoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCategoriaEstoque({ commit }, payload) {
      return CategoriaEstoqueService.PutCategoriaEstoque(payload).then(
        (categoriaEstoque) => {
          return Promise.resolve(categoriaEstoque);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCategoriaEstoque({ commit }, payload) {
      return CategoriaEstoqueService.DeleteCategoriaEstoque(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCategoriaEstoqueOData({ commit }, payload) {
      return CategoriaEstoqueService.GetCategoriaEstoqueOData(payload).then(
        (categoriaEstoque) => {
          return Promise.resolve(categoriaEstoque);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default categoriaEstoque;
